export default "__VITE_ASSET__Q2LJt3TJ__"